const FIELD_HEIGHT = 48;
const FIELD_GAP = 16;
export function calculateFormHeight(fieldsLength?: number | null) {
  return fieldsLength
    ? fieldsLength * FIELD_HEIGHT + (fieldsLength - 1) * FIELD_GAP
    : FIELD_HEIGHT;
}
